export const processSteps = [
  {
    step: "01",
    title: "Match",
    description: "We learn your budget, goals, and risk tolerance. Then we match you against our private inventory — not a public listing site. You receive a curated shortlist with real numbers.",
  },
  {
    step: "02",
    title: "Inspect",
    description: "Every property gets a structural review, utility check, and renovation estimate before you commit. We film the inspection and send it with English commentary. No surprises.",
  },
  {
    step: "03",
    title: "Purchase",
    description: "We handle the contract, notary, bank transfer, and registration. You need a Japanese bank account — we help you open one. No mortgage required. Cash only, as is standard for non-residents.",
  },
  {
    step: "04",
    title: "Renovate",
    description: "Our in-house team manages the renovation: permits, contractors, materials, and inspections. You get weekly photo updates and cost tracking. Typical timeline: 8–16 weeks.",
  },
  {
    step: "05",
    title: "Launch",
    description: "We set up rental platforms, local pricing, photography, and guest communication. If you need a minpaku or ryokan license, we file the paperwork. You go live with income from day one.",
  },
  {
    step: "06",
    title: "Operate",
    description: "Ongoing management: cleaning, maintenance, guest support, tax filing, and monthly reporting in English. You receive a P&L every month. We treat your property like our own.",
  },
];